import React from 'react';
import { Link } from 'react-router-dom';
import './LandingBanner.scss';

const LandingBanner = props => {
  return (
    <div className="cv-landing-banner">
      <div className="cv-landing-banner-logo" />
      <div className="cv-landing-banner-buttons">
        <Link className="cv-sign-in-btn" to={'/login'}>
          Sign In
        </Link>
        <Link className="cv-get-started-btn" to={'/signup'}>
          Get Started
        </Link>
      </div>
    </div>
  );
};

export default LandingBanner;
